import React from "react";
import OptionalTextInput from "./ValidatedFields/OptionalTextInput";

interface Props {
  value: string
  onChange: (newValue: string) => void;
  onEnter?: () => void;
  onEsc?: () => void;
  focusOnMount?: boolean;
}

export const convertToPhoneNumbers = (value: string): string[] => {
  return value.split(/,|;/).map(num => num.trim()).filter(num => num.length > 0)
}

export const PhoneInput = (props: Props) => {
  return (
    <OptionalTextInput
      focusOnMount={props.focusOnMount}
      value={props.value}
      onChange={props.onChange}
      maxLength={serverReference.constants.company.maxPhoneLength}
      onEnter={props.onEnter}
      onEsc={props.onEsc}
    />
  );
};